module.exports = __webpack_public_path__ + "img/ad.c1ff9b31.svg";